import React, { Component } from "react";
import { object } from "prop-types";
import { loadLastResult } from './lastResult';

class Result extends Component {
  static propTypes = {
    headerRef: object
  };

  constructor(props){
    super(props);

    this.state = {
      lastResult: loadLastResult()
    };
  }

  render(){
    return (
      <div>
        <h1 tabIndex={0} ref={this.props.headerRef}>
            Recent Results
        </h1>
        {
          this.state.lastResult && <p tabIndex={0}><b>{this.state.lastResult.lessonTitle}</b></p>
        }
        {
          this.state.lastResult && <p tabIndex={0}><b>{this.state.lastResult.wordCount}</b></p>
        }
        {
          this.state.lastResult && <p tabIndex={0}><b>{this.state.lastResult.wordsPerMin}</b></p>
        }
        {
          this.state.lastResult && <p tabIndex={0}><b>{this.state.lastResult.errors}</b></p>
        }
        {
          this.state.lastResult && <p tabIndex={0}><b>{this.state.lastResult.accuracy}</b></p>
        }
    </div>
    );
  };
};

export default Result;
